import { createSlice } from '@reduxjs/toolkit';

export const modalSlice = createSlice({
  name: 'modal',
  initialState: {
    isOpen: false,
    modalType: null,
    modalProps: null,
  },
  reducers: {
    openModal: (state, action) => ({
      isOpen: true,
      ...action.payload,
    }),
    clickModal: state => ({
      ...state,
      isOpen: false,
    }),
    closeModal: state => ({
      ...state,
      isOpen: false,
      modalType: null,
      modalProps: null,
    }),
    exitModal: () => ({
      isOpen: false,
      modalType: null,
      modalProps: null,
    }),
    setModalProps: (state, action) => ({
      ...state,
      modalProps: {
        ...state.modalProps,
        ...action.payload,
      },
    }),
    setOpen: (state, action) => ({
      ...state,
      isOpen: action.payload,
    }),
  },
});

export const {
  openModal,
  closeModal,
  exitModal,
  clickModal,
  setModalProps,
  setOpen,
} = modalSlice.actions;

export default modalSlice.reducer;
